import clsx from 'clsx';
import React, { useCallback, useId, useState } from 'react';
import { TimeFilterOption } from '../../interfaces/timeFilter';
import { getDataIdGenerator } from '../../../core/utils/generateDataId';
import { HdMenu, HdMenuItem } from '../../../components';
import styles from './TimeFilter.module.scss';

export interface TimeFilterProps {
  className?: string;
  dataId: string;
  options: TimeFilterOption[];
  activeOption: number;
  inlineFiltersCount?: number;
  onSelect: (option: TimeFilterOption) => void;
}

export function TimeFilter({
  className,
  dataId,
  options = [],
  activeOption,
  inlineFiltersCount = 3,
  onSelect
}: TimeFilterProps) {
  const [dropdownExpanded, setDropdownExpanded] = useState(false);
  const uniqueTriggerId = useId().replace(/:/g, '_');

  const dropdownTriggerId = `time_filter_dropdown_trigger${uniqueTriggerId}`;

  const dataIdGenerator = useCallback(getDataIdGenerator(dataId, 'timeFilter'), [dataId]);

  return (
    <div className={`${styles.filterBox} ${className}`} data-id={dataIdGenerator('')}>
      {options.slice(0, inlineFiltersCount).map((option, index) => (
        <button
          key={index}
          onClick={() => onSelect(option)}
          data-id={dataIdGenerator(`inline-option-${option.value}`)}
          className={clsx(
            'ml-1',
            styles.filterPellet,
            option.value === activeOption ? styles.activePellet : null
          )}
        >
          {option.name}
        </button>
      ))}

      {options.length > inlineFiltersCount ? (
        <>
          <button
            id={dropdownTriggerId}
            data-id={dataIdGenerator('dropdown-trigger')}
            onClick={e => {
              setDropdownExpanded(state => !state);
            }}
            className={styles.filterPellet}
          >
            ...
          </button>

          <HdMenu
            target={`#${dropdownTriggerId}`}
            open={dropdownExpanded}
            onClose={() => setDropdownExpanded(false)}
          >
            {options.slice(inlineFiltersCount).map((option, index) => (
              <HdMenuItem
                key={index}
                selected={option.value === activeOption}
                data-id={dataIdGenerator(`dropdown-option-${option.value}`)}
                onClick={() => {
                  onSelect(option);
                  setDropdownExpanded(false);
                }}
              >
                {option.name}
              </HdMenuItem>
            ))}
          </HdMenu>
        </>
      ) : null}
    </div>
  );
}
